import { SERVER_URL } from "../constants/ClientConfig";

const MAPI_URL = 'https://mapi.makemytrip.com/';
const MYBIZ_URL = 'https://corpcb.makemytrip.com/';
const MMT_URL = 'https://railways.makemytrip.com';

const CONFIG_STORE_URL = MAPI_URL + 'get/configKey';

/***  MyBiz Urls  ***/
const AUTO_SUGGEST_URL = MYBIZ_URL + 'v3/user/autosuggest/email?from=0&pagesize=20&viewManagerDetails=false';
const REQUISITION_DETAILS_URL = SERVER_URL + '/requisition/details?requisition_id=';
const TRIP_TAG_URL = SERVER_URL + '/tripTags';

/*** Traveller Urls ***/
const GET_IRCTC_USERNAME_URL = SERVER_URL + '/user/getIrctcUserName';
const UPDATE_IRCTC_USERNAME_URL = SERVER_URL + '/user/updateIrctcUserName';

/*** Aadhaar Verification Urls ***/
const GENERATE_AADHAAR_OTP_URL = MMT_URL + '/trains/booking/aadhaar/otp/generate';
const VERIFY_AADHAAR_OTP_URL = MMT_URL + '/trains/booking/aadhaar/otp/verify';
/*** Listing Urls ***/
const TBS_WITH_AVAILABILITY_URL = SERVER_URL + '/tbsWithAvailabilityAndRecommendation';

export const railsConfig = {
  configStoreUrl: CONFIG_STORE_URL,
  autoSuggestUrl:  AUTO_SUGGEST_URL,
  tripTagUrl: TRIP_TAG_URL,
  getIrctcUserNameUrl: GET_IRCTC_USERNAME_URL,
  updateIrctcUserName: UPDATE_IRCTC_USERNAME_URL,
  requisitionDetailsUrl:REQUISITION_DETAILS_URL,
  getAvailabilitySubscrnStatus: SERVER_URL + '/avlSubscription/status',
  updateAvailabilitySubscrnStatus: SERVER_URL + '/avlSubscription/update',
  generateAadhaarOtpUrl: GENERATE_AADHAAR_OTP_URL,
  verifyAadhaarOtpUrl: VERIFY_AADHAAR_OTP_URL,
  tbsWithAvailabilityUrl: TBS_WITH_AVAILABILITY_URL,
}